export function getUserState(user: any): "PUBLIC" | "RETURNING" | "AUTHENTICATED" {
  if (user) return "AUTHENTICATED";
  if (localStorage.getItem("rc_has_account") === "true") return "RETURNING";
  return "PUBLIC";
}

export function setUserHasAccount(): void {
  localStorage.setItem("rc_has_account", "true");
}

export function clearUserAccount(): void {
  localStorage.removeItem("rc_has_account");
}
